import { Validators } from '@angular/forms';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BaseService } from 'src/app/core/services/base.service';
import { Component, EventEmitter, Input, OnInit, Output, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-pos-capture-payment',
  templateUrl: './pos-capture-payment.component.html',
  styleUrls: ['./pos-capture-payment.component.scss']
})
export class PosCapturePaymentComponent implements OnInit {
  @Input() totalOrderOutstanding: number;
  @Input() amountOutstanding: number;
  @Input() salesOrderNumber: string;
  @Input() customerCode: string;
  @Input() invoiceNumber: string;
  @Input() paymentType: string;
  @Input() eftRefundRequestId: number;

  @Output() paymentChanged: EventEmitter<any> = new EventEmitter<any>(null);
  @Output() refundReasonChanged: EventEmitter<any> = new EventEmitter<any>(null);

  stores: {
    storeId: number;
    storeName: string;
    containers: {
      containerId: number;
      containerDesc: string;
      equipmentTypeCode: string;
      hasOpenBatch: boolean;
    }[];
    refundReasons: {
      refundReasonId: number;
      refundReasonDesc: string;
    }[];
  }[] = [];

  containers: {
    containerId: number;
    containerDesc: string;
    equipmentTypeCode: string;
    hasOpenBatch: boolean;
  }[] = [];

  refundReasons:{
    refundReasonId: number;
    refundReasonDesc: string;
  }[] = [];

  form: FormGroup;
  equipmentTypeCode: string;
  containerDesc: string;
  hasOpenBatch: boolean;
  loading: boolean = true;

  constructor(
    private baseService: BaseService,
    private fb: FormBuilder
  ) {
    this.form = fb.group({
      storeId: [null],
      containerId: [null, Validators.compose([Validators.required])],
      refundReasonId: [null]
    });
  }

  ngOnInit() {
    this.baseService.executeCommand<any[]>('portal_pos_payment_store_equipment_config', {
      salesOrderNumber: this.salesOrderNumber,
      invoiceNumber: this.invoiceNumber,
      customerCode: this.customerCode,
      paymentType: this.paymentType,
      amountOutstanding: this.amountOutstanding,
      eftRefundRequestId: this.eftRefundRequestId
    }).subscribe(
      response => {
        if (response.responseCode === 0) {
          this.stores = response.data || [];
          if (this.stores.length === 1) {
            this.form.controls['storeId'].setValue(this.stores[0].storeId);
            this.storeChanged();
          }
          this.loading = false;
        } else {
          this.loading = false;
        }
      },
      error => {
        this.loading = false;
      });
  }

  storeChanged() {
    this.form.controls['containerId'].reset();
    this.form.controls['containerId'].updateValueAndValidity();

    this.form.controls['refundReasonId'].clearValidators();
    this.form.controls['refundReasonId'].reset();
    this.form.controls['refundReasonId'].updateValueAndValidity();

    if (this.form.value.storeId) {
      const selectedStore = this.stores.find(f => f.storeId === this.form.value.storeId);
      if (selectedStore) {
        this.containers = selectedStore.containers || [];
        this.refundReasons = selectedStore.refundReasons || [];
        if (this.refundReasons.length > 0) {
          this.form.controls['refundReasonId'].setValidators(Validators.required);
          this.form.controls['refundReasonId'].updateValueAndValidity();
          if (this.refundReasons.length === 1) {
            this.form.controls['refundReasonId'].setValue(this.refundReasons[0].refundReasonId);
            this.onRefundReasonChanged();
          }
        }
      } else {
        this.containers = [];
        this.refundReasons = [];
      }
    } else {
      this.containers = [];
      this.refundReasons = [];
    }
  }


  containerChanged() {
    this.equipmentTypeCode = null;
    this.containerDesc = null;
    this.hasOpenBatch = false;

    setTimeout(() => {
      if (this.form.value.containerId) {
        this.equipmentTypeCode = this.containers.find(f => f.containerId === this.form.value.containerId).equipmentTypeCode;
        this.containerDesc = this.containers.find(f => f.containerId === this.form.value.containerId).containerDesc;
        this.hasOpenBatch = this.containers.find(f => f.containerId === this.form.value.containerId).hasOpenBatch;
      }
    }, 100);
  }

  formChanged(event: {
    containerId: number;
    formValid: boolean;
    formValue: any
  }) {
    this.paymentChanged.emit(Object.assign({ storeId: this.form.value.storeId }, event));
  }

  onRefundReasonChanged() {
    this.refundReasonChanged.emit({ refundReasonId: this.form.value.refundReasonId });
  }
}
